module.exports = __webpack_public_path__ + "img/hero/bring--medium.jpg";